// src/main.tsx or src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Unregister any previously-installed MSW service worker. Older builds
// registered `/mockServiceWorker.js` on every dev load; a stale copy left
// behind by those builds causes an infinite reload loop on subsequent
// visits until site data is cleared. This runs once per page load and
// self-cleans without any user action.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const scriptUrl = registration.active?.scriptURL || '';
      if (scriptUrl.includes('mockServiceWorker.js')) {
        registration.unregister();
      }
    });
  }).catch(() => {
    // Best-effort cleanup — ignore failures.
  });
}

// Render app immediately - don't wait for MSW
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);